import type { ResponseWithType } from './types';
import type { SourceEvent } from '../../types';

const sourceEvent = ({ data }: ResponseWithType<any>): SourceEvent => {
  return data;
};

export default sourceEvent;
